<template>
  <div class="py-4 container-fluid">
    <div class="d-flex card mb-4">
      <form @submit.prevent="" class="align-self-center card-body submit-ticket-form">
        <div class="row">
          <div>
            <label for="title" class="form-label required">عنوان تیکت</label>
            <input ref="titleInput" class="form-control" type="text" id="title" name="title" v-model.trim="title"
              @keydown.enter.prevent="focusDescTextarea" />
          </div>
          <div>
            <label for="description" class="form-label required">متن توضیحات</label>
            <div class="d-md-flex">
              <textarea ref="descTextarea" class="form-control" rows="3" id="description" name="description" v-model.trim="description" />
              <chat-file-selector ref="fileSelector" maxFileCount="5" :maxFileSize="50 * 1024 * 1024"
                validExtensions="rar,zip,doc,docx,pdf,xls,xlsx,ppt,pptx,txt,apng,png,avif,gif,jpg,jpeg,jfif,pjpeg,pjp,svg,webp"
                @filesUpdate="updateFiles" />
            </div>
          </div>
          <div class="col-md-6 mb-3">
            <label for="importance" class="form-label required">سطح اهمیت</label>
            <vue-select v-model="importance" :options="importances" dir="rtl" label="title">
              <template #no-options="{ search, searching, loading }">
                موردی یافت نشد!
              </template>
            </vue-select>
          </div>
          <div class="col-md-6 mb-3">
            <label for="section" class="form-label required">بخش مرتبط</label>
            <vue-select v-model="section" :options="companySections" dir="rtl" label="title">
              <template #no-options="{ search, searching, loading }">
                موردی یافت نشد!
              </template>
            </vue-select>
          </div>
          <div v-if="forCompanyUser" class="row ps-0 col-12">
            <hr class="horizontal dark mt-2" />
            <p>*در صورتی که می‌خواهید از جانب یک کاربر مشتری تیکت ثبت کنید، کاربر موردنظر را انتخاب کنید</p>
            <div class="col-md-6">
              <label class="form-control-label" for="holdingCompanyTitle">مشتری</label>
              <treeselect v-model="customerId" :multiple="false" :placeholder="'انتخاب مشتری'" :showCount="true"
                noOptionsText="هنوز مشتری‌ای تعریف نشده است" noResultsText="موردی یافت نشد"
                noChildrenText="این مشتری فاقد زیر مجموعه است" :options="customers" />
            </div>
            <div class="col-md-6">
              <label for="section" class="form-label">کاربر مشتری</label>
              <vue-select v-model="user" :options="users" dir="rtl" label="displayProp">
                <template #no-options="{ search, searching, loading }">
                  موردی یافت نشد!
                </template>
              </vue-select>
            </div>
            <hr class="horizontal dark mt-3" />
          </div>
        </div>
        <template v-if="v.$error">
          <show-errors :model-value="v.$errors"></show-errors>
          <hr class="horizontal dark" />
        </template>
        <div>
          <button class="btn bg-gradient-success mb-0" type="submit" :disabled="lockButtons" @click="submitForm">ثبت</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import CompanyService from '@/services/Company/Company-service.js';
import BaseService from '../../services/Base-service';
import { maxLength, helpers, required } from '@vuelidate/validators';
import Treeselect from '@cholakovdev/vue3-treeselect';
import UserService from '@/services/User/User-service.js';
import FileSelector from '../components/File/FileSelector.vue';
import ChatFileSelector from '../components/File/ChatFileSelector.vue';

export default {
  components: { Treeselect, FileSelector, ChatFileSelector },
  data() {
    return {
      v: this.$useVuelidate(),
      title: '',
      description: '',
      section: null,
      companySections: [],
      customerId: null,
      customers: [],
      user: null,
      users: [],
      importances: [
        { value: 0, title: 'پایین' },
        { value: 1, title: 'متوسط' },
        { value: 2, title: 'بالا' }
      ],
      importance: { value: 1, title: 'متوسط' },
      files: [],
      forCompanyUser: false,
      lockButtons: false,
    }
  },
  watch: {
    customerId(customerId) {
      this.users = [];
      this.user = null;
      
      if (customerId) {
        this.getUsersByCustomer();
      }
    },
    companySections(sections){
      if(sections.length > 0){
        this.section = sections[sections.findIndex((value) => value.isTicketingDefault)];
      }
    }
  },
  methods: {
    getCompanySections() {
      let companyId = this.$store.state.currentUserInfo.companyId;
      let customerId = this.$store.state.currentUserInfo.customerId;

      if (this.forCompanyUser){
        CompanyService.getSectionsForReferringByCompanyId(companyId).then(response => {
          let result = response.data;
          if (result.success) {
            this.companySections = result.data;
          }
          else{
            this.$toast.error(result.message);
          }
        }).catch(e => {
          console.log(e);
        });
      }
      else{
        CompanyService.getCompanySectionsForCustomer(companyId, customerId).then(response => {
          let result = response.data;
          if (result.success) {
            this.companySections = result.data;
          }
          else{
            this.$toast.error(result.message);
          }
        }).catch(e => {
          console.log(e);
        });
      }
    },
    submitForm() {
      this.v.$validate();
      if (this.v.$error) {
        return;
      }

      this.lockButtons = true;

      let ticket = new FormData();
      ticket.append('CompanySectionId', this.section.id);
      ticket.append('Title', this.title);
      ticket.append('TicketImportanceEnum', this.importance.value);
      ticket.append('TicketDetailMessage', this.description);
      if (this.user) {
        ticket.append('UserId', this.user.id);
      }
      for (var i = 0; i < this.files.length; i++) {
        ticket.append("Files", this.files[i]);
      }

      if (this.forCompanyUser) {
        BaseService.postFile('/Ticket/CompanyCreateTicket', ticket).then(response => {
          let result = response.data;

          if (!result.success) {
            this.$toast.error(result.message);
          } else {
            this.$toast.success(result.message);

            setTimeout(() => this.$router.push({path: '/myTickets', query: {tabKey: 1, pageIndex: 0, pageSize: 10}}), 500);
          }
        }).catch(e => {
          console.log(e);
        });
      }
      else {
        BaseService.postFile('/Ticket/CreateTicket', ticket).then(response => {
          let result = response.data;

          if (!result.success) {
            this.$toast.error(result.message);
          } else {
            this.$toast.success(result.message);

            setTimeout(() => this.$router.push({path: '/myTickets', query: {tabKey: 1, pageIndex: 0, pageSize: 10}}), 500);
          }
        }).catch(e => {
          console.log(e);
        });
      }

      this.lockButtons = false;
      this.v.$reset();
    },
    updateFiles(files) {
      this.files = files;
    },
    getUsersByCustomer() {
      UserService.getListByCustomerId(this.customerId).then(response => {
        let result = response.data;
        if (result.success) {
          this.users = result.data.map(user => ({ ...user, displayProp: (user.lastName + ' ' + user.firstName + ' - ' + user.postTitle) }));
        }
        else {
          this.$toast.error(result.message);
        }
      }).catch(e => {
        console.log(e);
      });
    },
    focusTitleInput() {
      this.$refs.titleInput?.focus();
    },
    focusDescTextarea() {
      this.$refs.descTextarea?.focus();
    }
  },
  created() {
    this.forCompanyUser = this.$store.state.currentUserInfo.isCompanyUser;
    this.getCompanySections();
    this.customers = this.$store.state.currentUserInfo.customers;

    setTimeout(() => {
      this.focusTitleInput();
    }, 100);
  },
  validations() {
    let valObj = {
      title: {
        required: helpers.withMessage('لطفا "عنوان تیکت" را وارد کنید', required),
        maxLength: helpers.withMessage('حد‌اکثر طول مجاز برای "عنوان تیکت"، 250 کاراکتر است', maxLength(250)),
      },
      section: {
        required: helpers.withMessage('لطفا "بخش مرتبط" را انتخاب کنید', required),
      },
      importance: {
        required: helpers.withMessage('لطفا "سطح اهمیت" را انتخاب کنید', required),
      },
      description: {
        required: helpers.withMessage('لطفا "متن توضیحات" را وارد کنید', required),
        maxLength: helpers.withMessage('حد‌اکثر طول مجاز برای "متن توضیحات"، 65000 کاراکتر است', maxLength(65000)),
      },
    };

    return valObj;
  },
}
</script>